window.$ = window.jQuery

import {theme} from '../framework/js/core'
import {BrowserDetect} from '../framework/js/common'
import {Cookie} from '../framework/plugins/Cookie/Cookie'

/**
 * Unfortunately, for now dynamic autoload is impossible with browserify static paths analysis
 * This means, that every block should be registered manually with full path as a string
 * not as any sort of valuable or function
 */

import {Environment} from '../blocks/Skeleton/Environment'

import {Header} from '../blocks/Skeleton/Header/Header'
import {Footer} from '../blocks/Skeleton/Footer/Footer'

import {CateringSummaryList} from '../blocks/Layout/CateringSummaryList/CateringSummaryList'
import {ContentBlock} from '../blocks/Layout/ContentBlock/ContentBlock'
import {ContactForm} from '../blocks/Layout/ContactForm/ContactForm'
import {WeeklyMenu} from '../blocks/Layout/WeeklyMenu/WeeklyMenu'
import {ImageSlider} from '../blocks/Layout/ImageSlider/ImageSlider'
import {Map} from '../blocks/Layout/Map/Map'


jQuery(() => {

  theme.addBreakpoint('xlarge', 1200, 960)
  theme.addBreakpoint('container', 1100, 900)
  theme.addBreakpoint('large', 900, 800)
  theme.addBreakpoint('normal', 720, 720)
  theme.addBreakpoint('small', 540, 540)

  theme.setDebug(false)

  theme.registerBlock(Environment, window.document)

  theme.registerBlock(Header, '#site-header')
  theme.registerBlock(Footer, '#site-footer')

  theme.registerBlock(CateringSummaryList, 'section.cs-list')
  theme.registerBlock(ContentBlock, 'section.content-block')
  theme.registerBlock(ContactForm, 'section.contact-form')
  theme.registerBlock(WeeklyMenu, 'section.weekly-menu')
  theme.registerBlock(ImageSlider, 'section.image-slider')
  theme.registerBlock(Map, 'section.google-map')

  theme.init()
})
